import { withDependencies } from '@wix/thunderbolt-ioc'
import type { IFetchApi } from '@wix/thunderbolt-symbols'
import { Fetch } from '@wix/thunderbolt-symbols'
import type { ExternalComponentFetchApi } from '../types'
import { getFetchWithTimeoutFunc } from '../utils/getFetchWithTimeoutFunc'

export const ClientFetchFactory = ({ timeout, maxRetries }: { timeout?: number; maxRetries?: number }) => {
	return withDependencies(
		[Fetch],
		(fetchApi: IFetchApi): ExternalComponentFetchApi => {
			return getFetchWithTimeoutFunc({ fetchFn: fetchApi.envFetch, timeout, maxRetries })
		}
	)
}
